import { getNIMConfig } from '../config'
import { toast } from './utils'
// 发送消息
export function getHistoryMsgs (nim, { to, scene = 'team', endTime = new Date().getTime(), asc = true, limit = 100 }) {
  if (!nim) return false
  return new Promise((resolve, reject) => {
    nim.getHistoryMsgs({
      scene,
      to,
      limit,
      asc,
      endTime,
      done: (err, obj) => {
        if (err) reject(new Error(`${err.message || '获取历史消息记录异常'}`))
        resolve(obj.msgs)
      }
    })
  })
}
// 初始化连接
export function initConnectNIM (userInfo, onMsg) {
  let nimConfig = getNIMConfig()
  return new Promise(function (resolve, reject) {
    window.nim = window.NIM.getInstance({
      debug: false,
      appKey: nimConfig.appkey,
      account: userInfo.token_im,
      token: userInfo.token_im,
      db: false,
      onerror: (error) => {
        if (error) window.location.reload()
      },
      onconnect: () => {
        resolve({ nim: window.nim, syncStatus: true })
      },
      ondisconnect: (error) => {
        switch (error.code) {
          case 302:
            reject('IM账号密码错误')
            break
          case 'kicked':
            reject(`你的帐号于${new Date()}被${error.from || '其他端'}踢出下线，请确定帐号信息安全!`)
            break
          default:
            break
        }
      },
      onwillreconnect: () => {
        toast({ msg: '正在重新连接IM,请稍等', type: 'warning', title: '提示' })
      },
      onteams: () => {
        //console.log('所有的群组', teams)
      },
      onmsg: onMsg,
      onsysmsg: onMsg,
      oncustomsysmsg: onMsg,
      onsyncdone: () => {
        console.log('同步完成')
      }
    })
  })
}